import styles from "./index.css";
import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import classnames from "classnames";

const SellingFastBadge = ({ className, formatTranslation }) => (
  <div className={classnames(styles.sellingFastBadge, className)}>
    {formatTranslation("selling_fast_label")}
  </div>
);

SellingFastBadge.propTypes = {
  isSellingFast: PropTypes.bool,
  className: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SellingFastBadge);
